import { render, staticRenderFns } from "./MdInjectionAssessmentNotes.vue?vue&type=template&id=67067347&"
import script from "./MdInjectionAssessmentNotes.vue?vue&type=script&lang=js&"
export * from "./MdInjectionAssessmentNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports